import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import * as yup from 'yup';

import Input from '../../../lib/Form/Input';
import PasswordFormControl from '../../../lib/Form/PasswordFormControl';
import Select from '../../../lib/Form/Select';
import CustomModal from '../CustomModal';

const AddNetworkModal = ({
  modal,
  onHide,
  onAddNetwork,
  loading = false,
  securityModes,
}) => {
  const openSecurityModes = securityModes.reduce((result, mode) => {
    return mode.requiresPassphrase
      ? result
      : [...result, mode.name.toUpperCase()];
  }, []);

  const schema = yup.object().shape({
    ssid: yup.string().required('Network name is required.'),
    security: yup.string().required('Please select security.'),
    passphrase: yup.string().when('security', {
      is: (pass) => {
        return !openSecurityModes.includes(pass?.toUpperCase());
      },
      then: (pass) => pass.required('Password is required.'),
    }),
  });

  return (
    <CustomModal modal={modal} onHide={onHide} size="md">
      <CustomModal.Header onHide={onHide}>
        Add a Wi-Fi Network
      </CustomModal.Header>
      <Formik
        validationSchema={schema}
        onSubmit={onAddNetwork}
        initialValues={{
          ssid: '',
          passphrase: '',
          security: '',
        }}
      >
        {(formik) => (
          <Form noValidate onSubmit={formik.handleSubmit}>
            <CustomModal.Body>
              <Input
                label="Network Name"
                groupClassName="padded-control"
                name="ssid"
              />

              <Select
                name="security"
                label="Security"
                groupClassName="padded-control"
                onChange={(event) => {
                  formik.setFieldValue('security', event.target.value);
                  formik.setFieldValue('passphrase', '');
                }}
              >
                <option key="select" value="">
                  Select
                </option>
                {securityModes.map((protocolOption) => (
                  <option key={protocolOption.name} value={protocolOption.name}>
                    {protocolOption.label}
                  </option>
                ))}
              </Select>
              {!!formik.values.security &&
                !openSecurityModes.includes(
                  formik.values.security.toUpperCase(),
                ) && (
                  <PasswordFormControl
                    name="passphrase"
                    groupClassName="padded-control"
                    label="Password"
                  />
                )}
            </CustomModal.Body>

            <CustomModal.Footer>
              <Button
                variant="link"
                className="text-capitalize"
                onClick={() => onHide(false)}
              >
                Cancel
              </Button>
              <Button type="submit" disabled={loading}>
                {loading ? 'Adding…' : 'Add'}
              </Button>
            </CustomModal.Footer>
          </Form>
        )}
      </Formik>
    </CustomModal>
  );
};

AddNetworkModal.propTypes = {
  loading: PropTypes.bool,
  modal: PropTypes.bool.isRequired,
  onAddNetwork: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  securityModes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      requiresPassphrase: PropTypes.bool.isRequired,
    }),
  ).isRequired,
};

export default AddNetworkModal;
